import DashboardIcon from "@mui/icons-material/Dashboard";
import CreateNewFolderIcon from '@mui/icons-material/CreateNewFolder';
import DnsIcon from '@mui/icons-material/Dns';
import SettingsIcon from "@mui/icons-material/Settings";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import LogoutIcon from "@mui/icons-material/Logout";
import MeetingRoomIcon from '@mui/icons-material/MeetingRoom';
import HotelClassIcon from '@mui/icons-material/HotelClass';
import { ROLES } from "../config/roles";

const menuItems = [
  { label: "Dashboard", icon: <DashboardIcon />, path: "/", roles: [ROLES.KIOSK] },
  { label: "New Project", icon: <CreateNewFolderIcon />, path: "/newproject", roles: [ROLES.KIOSK] },
  { label: "Project List", icon: <DnsIcon />, path: "/projects", roles: [ROLES.KIOSK] },
  { label: "Conference Room", icon: <MeetingRoomIcon />, path: "/conference-room", roles: [ROLES.KIOSK] },
  { label: "Customer Feedback", icon: <HotelClassIcon />, path: "/feedback", roles: [ROLES.KIOSK] },
  { label: "Settings", icon: <SettingsIcon />, path: "/settings", roles: [ROLES.KIOSK] },
  { label: "WhatsApp", icon: <WhatsAppIcon />, path: "/whatsapp", roles: [ROLES.KIOSK] },
  { label: "Logout", icon: <LogoutIcon />, path: "/logout", roles: [ROLES.KIOSK] },
  { label: "Finance Dashboard", icon: <LogoutIcon />, path: "/finance/get-projects", roles: [ROLES.OPERATIONS] },
];

export default menuItems;